import React from 'react';
import { COLORS } from '../../../styles/tokens';

// Kort hjelpetekst om bruksområde under et produkt- eller undervalg.
export default function MassHint({ text }) {
  if (!text) return null;
  return <div style={{ fontSize: 13, color: COLORS.textMid, lineHeight: 1.4, marginTop: -2 }}>{text}</div>;
}
